import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const TagText = (props) => {
  const {
    selectProps: { isDisabled, isTagTextClipped },
    children,
  } = props;

  const classes = classNames('ws-ui-tag-input-tag-text', {
    'ws-ui-tag-input-tag-text--is-disabled': isDisabled,
    'ws-ui-tag-input-tag-text--is-clipped': isTagTextClipped,
  });
  return <div className={classes}>{children}</div>;
};

TagText.propTypes = {
  selectProps: PropTypes.shape({
    isDisabled: PropTypes.bool.isRequired,
    isTagTextClipped: PropTypes.bool.isRequired,
  }).isRequired,
  children: PropTypes.node.isRequired,
};

export default TagText;
